export function terminationAgreementBuyerListingCP826() {
return [   // Release 2026-09-08 18:00:01
 
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 49.92,
   left: 256.08,
   width: 316.56,
   height: 13.20
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 125.0,
   left: 216.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 148.16,
   left: 217.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.44,
   left: 217.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 194.6,
   left: 217.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Date Buyer Listing Contract Date", 
   fontSize: 9,
   type: "date",
   top: 217.76,
   left: 217.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Amount Termination Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 240.92,
   left: 217.12,
   width: 323.52,
   height: 14.051
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 671.389,
   left: 288.12,
   width: 246.72,
   height: 14.051
}
,
{
   page: 0,
   name: "Signature Buyer", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 698.8037,
   left: 72.0,
   width: 356.28,
   height: 13.3963
}
,
{
   page: 0,
   name: "Date Signature Buyer", 
   fontSize: 9,
   type: "date",
   top: 698.1491,
   left: 468.24,
   width: 71.40,
   height: 14.0509
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 753.6,
   left: 74.04,
   width: 300.48,
   height: 9.96
}
] }
